import {

    getTicketById,
    getViewTicketById,
    getClientTickets,
    getClientTicketTask,
    getEditTicketById,
    reopenCustomerTicket,
    reopenOfficeEntityTicket,
    uploadTicketDocument,
    getTicketDocument,
    reassignTicket,
    getTicketDetailsById,
    cancelSubTaskTicket,
    getUploadedDocumentData,
    updateSubTicket,
} from "@/http/customer/customer";

export default {
    namespaced: true,
    state: {
        ticketViewById: [],
        ticketViewDataById: {
            feedback: []
        },
        tickets: [],
        ticketTask: [],
        ticketById: {},
        ticketDetailsById: {},
        ticketDocumentData: null,
        documentData: {},
    },
    actions: {
        async setsTicketById({ commit }, id) {
            const resp = await getTicketById(id);
            commit("SET_TICKETVIEW_BY_ID", resp.data);
            return resp;
        },
 async setViewTicketById({ commit }, id) {
  const resp = await getViewTicketById(id);

  if (resp && resp.data) {
    commit("SET_CUSTOMER_TICKETVIEW_BY_ID", resp.data);
  } else {
    console.error("Error fetching ticket by ID:", error);
      commit("CLEAR_VIEW_TICKET");
      throw error;
  }

  return resp;
},
        async setClientTickets({ commit }, data) {
            const response = await getClientTickets(data);
            commit("SET_CLIENT_TICKETS", response.data);
            return response
        },
        async setClientTicketTask({ commit }, data) {
            const response = await getClientTicketTask(data);
            commit("SET_CLIENT_TICKETS_TASK", response.data);
            return response
        },
        async cancelSubTaskTicketAction(_, data) {
            const response = await cancelSubTaskTicket(data.taskId, data.data);
            return response;
        },
        async setTicketById({ commit }, data) {
            const resp = await getEditTicketById(data.clientId, data.id);
            commit("SET_TICKET_BY_ID", resp.data);
            return resp;
        },
        async getTicketDetailsByIdAction({ commit }, data) {
            const resp = await getTicketDetailsById(data.id);
            commit("SET_TICKET_DETAILS_BY_ID", resp.data);
            return resp;
        },
        async getTicketDocumentAction({ commit }, data) {
            const resp = await getTicketDocument(data);
            commit("SET_TICKET_DOCUMENT", resp.data);
            return resp;
        },
        async getUploadedDocumentDataAction({ commit }, data) {
            const resp = await getUploadedDocumentData(data.ticketId, data.docId, data.showImages);
            commit("SET_DOCUMENT_DATA", resp.data);
            return resp;
        },
        async clearTicketDocument({ commit }) {
            commit("CLEAR_TICKET_DOCUMENT");
        },
        async reassignTicketAction(_, data) {
            const resp = await reassignTicket(data.id, data.data);
            return resp;
        },
        async updateSubTicketAction(_, data) {
            const resp = await updateSubTicket(data.id, data.data);
            return resp;
        },
        async reopenCustomerTicketAction(_, data) {
            const resp = await reopenCustomerTicket(data.id, data.data);
            return resp;
        },
        async reopenOfficeEntityTicketAction(_, data) {
            const resp = await reopenOfficeEntityTicket(data.id, data.data);
            return resp;
        },
        async uploadTicketDocumentAction(_, data) {
            const resp = await uploadTicketDocument(data.id, data.data);
            return resp;
        },
    },
    mutations: {
        SET_TICKETVIEW_BY_ID(state, payload) {
            state.ticketViewById = payload;
        },
        SET_CUSTOMER_TICKETVIEW_BY_ID(state, payload) {
            state.ticketViewDataById = payload;
        },
        CLEAR_VIEW_TICKET(state) {
            state.ticketViewDataById = {feedback: []};
        }, 
        SET_TICKET_DOCUMENT(state, payload) {
            state.ticketDocumentData = payload;
        },
        CLEAR_TICKET_DOCUMENT(state) {
            state.ticketDocumentData = null;
        },
        SET_CLIENT_TICKETS(state, payload) {
            state.tickets = payload;
        },
        SET_CLIENT_TICKETS_TASK(state, payload) {
            state.ticketTask = payload;
        },
        SET_TICKET_BY_ID(state, payload) {
            state.ticketById = payload;
        },
        SET_TICKET_DETAILS_BY_ID(state, payload) {
            state.ticketDetailsById = payload;
        },
        SET_DOCUMENT_DATA(state, payload) {
            state.documentData = payload;
        },
    },
    getters: {
        getClientTickets(state) {
            return state.tickets;
        },
        getClientTicketTask(state) {
            return state.ticketTask;
        },
    },
};
